import { serializeContact } from "@/components/autocomplete/usePresenterContacts";

import type { DustClass, DustClassNew } from "@/views/dustClass/dustClass";
import { toTimeOnlyString } from "@modernary/mui/utils/fk";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  requestAdapter,
  toFormkit,
  fromFormkit,
};

function addAuthRequestFields(entity: DustClass) {
  entity._authRequestFields = ["id"];
  return entity;
}
function getInitialData() {
  const result = {} as DustClass; //TODO: ts
  return addAuthRequestFields(result);
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: DustClass }) {
  addAuthRequestFields(response.data);

  if (!response.data.presentedByObj) response.data.presentedByObj = {};
  if (response.data.presentedBy) {
    response.data.presentedByObj = JSON.parse(response.data.presentedBy);
  }

  if (!response.data.coHostedByObj) response.data.coHostedByObj = {};
  if (response.data.coHostedBy) {
    response.data.coHostedByObj = JSON.parse(response.data.coHostedBy);
  }

  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: DustClass }) {
  await skinnyResponseAdapter(response);
  return response.data;
}

function requestAdapter(data: DustClass) {
  if (!data.id) {
    delete data.attendees;
  } else if (data.attendees) {
    data.attendees = data.attendees.map((attendee) => ({
      id: attendee.id,
      firstName: attendee.firstName,
      lastName: attendee.lastName,
      email: attendee.email,
      businessName: attendee.businessName,
      hasAttended: attendee.hasAttended ?? null,
    })) as DustClass["attendees"];
  }

  return data;
}

// Convert server data for use in the page's form
function toFormkit<T extends DustClass | DustClassNew>(data: T) {
  if (!data.presentedByObj) data.presentedByObj = {};
  if (!data.coHostedByObj) data.coHostedByObj = {};
}

// Convert formkit data to prep it for sending to the server
function fromFormkit(data: DustClass) {
  if (data.classLocalTime) data.classLocalTime = toTimeOnlyString(data.classLocalTime);

  data.presentedByEmail = data.presentedByObj?.email || null;
  data.presentedBy = serializeContact(data.presentedByObj);
  data.coHostedByEmail = data.coHostedByObj?.email || null;
  data.coHostedBy = serializeContact(data.coHostedByObj);
}
